import { render, staticRenderFns } from "./CampaignsListCard.vue?vue&type=template&id=0cfbfd26"
import script from "./CampaignsListCard.vue?vue&type=script&lang=js"
export * from "./CampaignsListCard.vue?vue&type=script&lang=js"
import style0 from "./CampaignsListCard.vue?vue&type=style&index=0&id=0cfbfd26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports